@if(universalService.activeRepo == 'main'){
  <common-otp-verification/>
  @if (universalService.purchaseModalType != '') {
    <lib-purchase-success [modalType]="universalService.purchaseModalType" (closeModal)="closeModal()"/>
  }
  @if (this.universalService.show2FApopUp) {
    <lib-passphrase-login/>
  }
  <!-- @if (this.universalService.showRecoverpopUp||this.universalService.showRecoverVerifyemailpopUp|| this.universalService.recoverVerifyOTPpopUp) {
    <lib-recover-account/>
  }
  @if (this.loginImplRef.showTrobledSigninModalToUsr) {
    <lib-display-usr-details-modal/>
  }
  @if (this.loginImplRef.noMappingFoundModal) {
    <lib-no-mapping-found-modal/>
  } -->
  @if (!router.url.includes('/userprofile') && universalService.showPassPhraseReset) {
    <lib-reset-passpharse/>
  }
}
<a name="goToTop" aria-hidden="true" rel="noopener noreferrer"></a>
@if (this.landingService.landingPageData) {
  <lib-not-supported [browserSupported]="universalService.isSupprtedBrowser"/>
  <header id="landing-header" class="main-wrapper" [class.hide]="isHidden">
    @if(universalService.showDownTimeBanner){
      <div class="downtime-banner">
        <span>JioAICloud may be briefly disrupted from 12:00 AM to 2:00 AM on February 21st due to a system upgrade.</span>
        <span class="Neueclosefilled" (click)="closeDownTimeBanner()"></span>
      </div>
    }
    <div class="desktop-header m-mobile-header" [ngClass]="(universalService.showDownTimeBanner || !universalService.isSupprtedBrowser) ? 'add-margin-top': ''">
      <div class="row header-fix-w" [ngClass]="universalService.isMobileDevice && (router.url.includes('/spinthewheel') || router.url.includes('/scratchtowin')) ? 'hideOnGamepage' : '' ">
        <div class="col-3 pr-0 mr-0 pl-0">
          <div class="jc-logo d-none d-lg-block">
            <span (click)="loggedInRedirection('about')" style="cursor: pointer;">
              <span class="NeueCloudFilled"></span>
              @defer{
                <span class="logo-txt">{{'appName' | translate}}</span>
              }
            </span>
          </div>
          <!-- Mob Hamburger -->
          <!-- <span class="NeueDragHandle pt-1 d-inline-block d-lg-none" (click)="this.openMobileMenuOptions()"></span> -->
          <!-- <img src="{{this.landingService.landingPageData[10].hamburgerIcon}}" (click)="this.openMobileMenuOptions()" class="d-lg-none m-ham"> -->
          @if (!this.landingService.isDarkTheme  || this.router.url != ('/') ) {
            <img src="https://static.jiocloud.com/web2.0/landing/Images/icon-hamburger.svg" (click)="this.openMobileMenuOptions()" class="d-lg-none m-ham" alt="JioAICloud Theme">
          }
          @if (this.landingService.isDarkTheme  && this.router.url == ('/')) {
            <img src="https://static.jiocloud.com/web2.0/landing/Images/icon-hamburger.svg" (click)="this.openMobileMenuOptions()" class="d-lg-none m-ham" alt="JioAICloud Theme">
          }
        </div>
        <div class="col-lg-6 text-center ml-0 mr-0 pl-0 pt-0 pr-0 pb-0" id="navigation" [ngClass]="router.url.includes('signin') ? 'col-6' : 'col-6'">
          @if(universalService.isMobileDevice && (this.router.url == ('/') || router.url.includes('/downloadApp')|| router.url.includes('features') || router.url.includes('signin'))){
            <span class="NeueCloudFilled jioMobileHeaderLogo" (click)="logoRedirection()"></span>
          }
          @if (!this.universalService.isMobileDevice) {
            <nav class="desk-nav" aria-labelledby="navigation">
              <ul>
                @for (list of headerLinkList; track list) {
                  @if(list.name == 'home'){
                    <li class="link5" [ngClass]="(router.url == '/' && list.name == 'home') ? 'active' : ''">
                      <a [ngStyle]="{'background-size' : ((router.url.indexOf('/features') >= 0 ) ) ? '100%':''}" href="javascript:void(0)" title="{{list.title}}" target="{{list.target}}" rel="noopener noreferrer" (click)="logoRedirection()">{{list.name | translate }}</a>
                    </li>
                  }@else{
                    <li class="link5" [ngClass]="(router.url == '/' && list.name == 'home') || (router.url == '/downloadApp' && list.name == 'downloads') ? 'active' : ''">
                      @if (list.name == 'pricing') {
                        <span class="new" (click)="redirectToRespectivePages(list.name)">{{'beta' | translate}}</span>
                      }
                      @if (list.name !='JioTransfer') {
                        @if (router.url.includes('/downloadApp') && list.name !='enterprise') {
                          <a [ngStyle]="{'background-size' : (list.name == 'whatsNew' && (router.url.indexOf('/features') >= 0 ) ||(list.name == 'pricing' &&  router.url.indexOf('/pricing') >= 0 )) ? '100%':''}" href="{{list.redirectionUrl}}" title="{{list.title}}" target="{{list.target}}" rel="noopener noreferrer">{{list.name | translate }}</a>
                        }@else{
                        <a [ngStyle]="{'background-size' : (list.name == 'whatsNew' && (router.url.indexOf('/features') >= 0 ) ||(list.name == 'pricing' &&  router.url.indexOf('/pricing') >= 0 )) ? '100%':''}" href="{{list.redirectionUrl}}" title="{{list.title}}" target="{{list.target}}" rel="noopener noreferrer">{{list.name | translate }}</a>
                        }
                      }
                      @if (list.name =='JioTransfer') {
                        <a href="{{this.jtrUrl}}" title="{{list.title}}" target="{{list.target}}" rel="noopener noreferrer">{{list.name | translate }}</a>
                      }
                    </li>
                  }
                 
                }
                <!-- <li class="dropdown link5 txt-more" (mouseleave)="showMoreOptions=false">
                  <a class="more-options-dropdown" href="javascript:void(0)" rel="noopener noreferrer">
                    @if (router.url.includes('/downloadApp')) {
                      <div class="pointer" (click)="showMoreOptionsDropDown()">More<span class="NeueExpand dots"></span></div>
                    }@else{
                      <div class="pointer" (click)="showMoreOptionsDropDown()">{{'headerMoreOption' | translate}}<span class="NeueExpand dots"></span></div>
                    }
                    @if (showMoreOptions) {
                      <ul class="drop-menu" [ngClass]="[universalService.isDarkTheme && this.router.url == ('/') ? 'dark-background' : 'light-background']">
                        @for (option of headerMoreOptionsList; track option) {
                          <li class="link5" role="presentation">
                            <a target="_blank" href="{{option.link}}" class="{{option.name}}" tabindex="-1" title="{{option.title}}" rel="noopener noreferrer">{{option.name | translate}}</a>
                          </li>
                        }
                      </ul>
                    }
                  </a>
                </li> -->
              </ul>
            </nav>
          }
        </div>
        <div class="col-3 pl-0 ml-0 pr-0 opt-cont" [ngClass]="!this.universalService.userLandingLoggedIn && universalService.isMobileDevice && (router.url.includes('/spinthewheel') || router.url.includes('/scratchtowin')) ? 'hideOnWhenNotLoggedIn' : '' ">
          <!-- Mobile Login -->
          @if (!this.universalService.userLandingLoggedIn && !router.url.includes('signin') && !router.url.includes('spinthewheel') && !router.url.includes('scratchtowin') && universalService.isMobileDevice) {
            <!-- <button (click)="openLogin()" class="m-login text-right float-right d-inline-block d-lg-none">{{'signin' | translate }}</button> -->
            <span (click)="openLogin()" class="mob-header-login-btn NeueUserFilled"></span>
          }
          <!-- User Profile Icon -->
          @if (this.universalService.userLandingLoggedIn) {
            <div class="icon-user-profile float-right" (click)="loggedInRedirection('Profile')" style="position: relative; top: 16px;">
              <span class="icon-profile-holder NeueUserFilled mr-2" [ngClass]="[userDetails?.allowStoragePurchase == 'N' || userDetails?.authProviderId == '25' || userDetails?.jcEntInfo ? 'non-premiumuser-border':'',userDetails?.allowStoragePurchase == 'Y' && (userDetails?.paidPlan?.planStatus == 'A'||userDetails?.paidPlan?.planStatus == 'G')?'premiumuser-border':'non-premiumuser-border']"></span>
              <div class="icon-user-profile">
                <img src="{{universalService.profileIconPath}}" alt="" (error)="this.universalService.thumbnailError($event)" alt="JioAICloud Profile" [ngClass]="[userDetails?.allowStoragePurchase == 'N' || userDetails?.authProviderId == '25' || userDetails?.jcEntInfo ? 'non-premiumuser-border':'',userDetails?.allowStoragePurchase == 'Y' && (userDetails?.paidPlan?.planStatus == 'A'||userDetails?.paidPlan?.planStatus == 'G')?'premiumuser-border':'non-premiumuser-border']" />
              </div>
            </div>
          }
          <!-- User Profile Mobile -->
          <!-- LOGIN -->
          @if (!this.universalService.userLandingLoggedIn && !router.url.includes('signin') && !router.url.includes('spinthewheel') && !router.url.includes('scratchtowin')) {
            <button (click)="openLogin()" tabindex="0" role="button" class="btn btn-login float-left d-none d-lg-block">{{'signin' | translate }}</button>
          }
          <!-- LANGUAGE SWITCH -->
          @if(!universalService.isMultiLangNotSupported){
            <div class="lang-switch mr-1 d-none d-lg-block">
              <select name="themeLanguage" data-show-content="true" tabindex="0" aria-label="language select dropdown" class="form-control" id="themeLanguage" #selectedLang (change)="switchLanguage(selectedLang?.value,$event)">
                @for (lang of langList; track lang) {
                  <option value="{{lang.code}}">{{lang.name}}</option>
                }
              </select>
            </div>
          }
        </div>
    </div>
  </div>
  <!---- MOBILE DRAWER STARTS ---->
  @if (universalService.isMobileDevice) {
    <div class="m-drawer-main d-block d-lg-none">
      <!-- Navigation Items -->
      <div class="m-nav-inner pt-3 pl-3 pr-3 pb-3">
        <div class="header-utils">
          <div class="row">
            <div class="col text-left">
              <span class="NeueFile_Cancel" (click)="this.closeMobileMenuOptions()"></span>
            </div>
            <div class="col text-center pt-1" (click)="loggedInRedirection('about')">
              <span class="NeueCloudFilled"></span>
            </div>
            <div class="col text-right pt-0 mt-0">
              
          </div>
        </div>
      </div>
      <ul class="text-md-center">
        @for (list of headerLinkList; track list) {
          <li class="link5" [ngClass]="((list.redirectionUrl != undefined && router.url != '/' && list.redirectionUrl.indexOf(router.url) > -1) ? 'hidePricingTab' : '' )" >
            <a title="{{list.title}}" (click)="redirectToRespectivePages(list)" rel="noopener noreferrer">{{list.name | translate }} </a>
            @if (list.name == 'pricing') {
              <span class="new" (click)="redirectToRespectivePages(list.name)">
                {{'beta' | translate}}
                
              </span>
            }
          </li>
        }
        @if (universalService.showLangDropdown) {
          <li data-toggle="modal" data-target="#m-lang-modal" (click)="closeMobileMenuOptions()" >
            <a title="{{ 'changeLanguage' | translate }}" rel="noopener noreferrer" [ngClass]="(router.url.includes('about') || router.url.includes('contact-sales')) ? 'hide-ent-option' : '' ">{{'language' | translate}}</a>
          </li>
        }
        <!-- @for (list of headerMoreOptionsList; track list) {
          <li class="link5">
            <a title="{{list.title}}" (click)="redirectToRespectivePages(list)" rel="noopener noreferrer">{{list.name | translate }} </a>
        </li>
      } -->
    </ul>
  </div>
</div>
}
<!---- MOBILE DRAWER ENDS ---->
<!-- DRAWER OVERLAY STARTS -->
<!-- @if (this.router.url.includes('/downloadApp')) { -->
  <div id="drawer-overlay" class="d-lg-none" (click)="clickOutsideTheDrawer()"></div>
<!-- } -->
<!-- DRAWER OVERLAY ENDS -->
<!-- LANGUAGE SELECTION MODAL - MOBILE -->
@if (universalService.showLangDropdown) {
  <div id="m-lang-modal-main">
    <!-- Modal -->
    <div class="modal fade d-lg-none" id="m-lang-modal" tabindex="-1" role="dialog" aria-labelledby="m-lang-modal" aria-hidden="true" [ngStyle]="{'background': this.universalService.showLangDropdown && router.url.includes('/signin')  ? 'rgba(0,0,0,0.5)':'none', 'transition':'all ease-in .1s'}">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2>{{'selectLang'| translate}}</h2>
          </div>
          <div class="modal-body">
            <div class="m-lang-items">
              <ul>
                @for (lang of langList; track lang) {
                  <li (click)="switchLanguage(this.universalService.getThemeLanguage(),$event)" data-lang="{{lang.code}}" [ngClass]="(lang.code == this.universalService.getThemeLanguage()) ? 'active' : ''">
                    {{lang.name}}
                    @if (!(lang.code == this.universalService.getThemeLanguage())) {
                      <span class=" float-right pt-1"></span>
                    }
                    @if ((lang.code == this.universalService.getThemeLanguage())) {
                      <span class="NeueCheck float-right pt-1"></span>
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" data-dismiss="modal">{{'confirm' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<!-- GO TO TOP DESKTOP -->
<img src="https://static.jiocloud.com/web2.0/landing/Images/icon-go-to-top.png" id="go-to-top" role="scrollbar" aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" aria-controls="go-to-top" aria-orientation="vertical" (click)="goToTop()" alt="Go to top" title="Go to top" class="img-fluid">
</header>
}

@if (universalService.showLoader) {
  <div class="loader-overlay"></div>
}
@if (this.universalService.showLoader && !this.universalService.isMobileDevice) {
  <ng-lottie class="jiocloud_loader" width="170px" height="170px" containerClass="moving-box" [styles]="styles" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
}
@if (this.universalService.showLoader && this.universalService.isMobileDevice) {
  <ng-lottie class="jiocloud_loader" width="105px" height="150px" containerClass="moving-box" [styles]="styles" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
}